module.exports = __webpack_public_path__ + "img/house-medical.ca428d56.svg";